(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["customer-login-modal"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeAccountDialogs = (root = document) => {
      const dialogs = root.matches && root.matches('[data-account-dialog]')
        ? [root]
        : Array.from(root.querySelectorAll('[data-account-dialog]'));

      dialogs.forEach((dialog) => {
        if (dialog.dataset.accountDialogReady === 'true') return;
        dialog.dataset.accountDialogReady = 'true';

        const header = dialog.closest('aurenna-header') || document;
        const openers = Array.from(header.querySelectorAll(`[data-account-open="${dialog.id}"]`));
        const closer = dialog.querySelector('[data-account-close]');

        openers.forEach((opener) => {
          opener.addEventListener('click', () => {
            if (!dialog.open) dialog.showModal();
          });
        });

        if (closer) closer.addEventListener('click', () => dialog.close());

        dialog.addEventListener('click', (event) => {
          const rect = dialog.getBoundingClientRect();
          const outside = event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom;
          if (outside) dialog.close();
        });
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeAccountDialogs(), { once: true });
    } else {
      initializeAccountDialogs();
    }

    document.addEventListener('shopify:section:load', (event) => initializeAccountDialogs(event.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
